module.exports = __webpack_public_path__ + "img/jnhb.786a571.png";